/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/training.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';

const LearnerTraining = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '미수료', value: 0},
    {title: '1회', value: 1},
    {title: '2회', value: 2},
    {title: '3회 이상', value: 3},
    {title: '수료', value: 4}
  ];
  return (
    <main className="com_container com_training p_learner_training">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_2">신규 교육 대상자</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="기수 전체">기수 전체</option>
                </select>
                <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search">
                <div className="board_select">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">전체</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">교육배정</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">교육 미배정</label>
                  </div>
                </div>
                <span className="com_check_box">
                  <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                  <label htmlFor="chk010">교육대상자 추가</label>
                </span>
              </section>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="100" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="70" />
                <col width="auto" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="80" />
                <col width="80" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>합격일</th>
                  <th>지점</th>
                  <th>과목</th>
                  <th>이름</th>
                  <th>나이/성별</th>
                  <th>학력</th>
                  <th>면접</th>
                  <th>시강</th>
                  <th>등급</th>
                  <th>미수료회차</th>
                  <th>상태</th>
                  <th>배정상태</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className="td_date">2022,08,25</td>
                    <td>본사</td>
                    <td>수학</td>
                    <td>홍면접</td>
                    <td>29/남</td>
                    <td>울산과학기술원</td>
                    <td>35</td>
                    <td>37</td>
                    <td>C-</td>
                    <td>
                      <span className="btn_link red">완료</span>
                    </td>
                    <td className="td_point">우수</td>
                    <td className="td_point">
                      -1회 <br />
                      -2회 6기 <br />
                      -3회 미배정
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <div className="paging_wrap">
                <Paging />
              </div>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">교육 대상자 상세</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit"></button>
              </div>
            </div>
            <div className="com_icon blue fit_cont">미수료 1회</div>

            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">지점/과목</span>
                  <span className="cont">본사 / 영어</span>
                </div>
                <div className="info">
                  <span className="tit">이름</span>
                  <span className="cont bold">김교사</span>
                </div>
                <div className="info">
                  <span className="tit">나이/성별</span>
                  <span className="cont">1979,12 / 여</span>
                </div>
                <div className="info">
                  <span className="tit">거주지</span>
                  <span className="cont com_blue_txt">서울 / 송파구</span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <span className="cont com_blue_txt">010-1234-4567</span>
                </div>
                <div className="info">
                  <span className="tit">학력</span>
                  <span className="cont">서울 고려대 / 생명공학</span>
                </div>
                <div className="info">
                  <span className="tit">면접 유입경로</span>
                  <span className="cont">신규</span>
                </div>
                <div className="info">
                  <span className="tit">소개자</span>
                  <span className="cont">김소개103</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">면접관</span>
                  <span className="cont bold">김면접103</span>
                </div>
                <div className="info">
                  <span className="tit">기프트콘 발송</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">면접방식 </span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">면접일시</span>
                  <span className="cont">2023, 05, 12 15:30</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">시강점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">면접관 가산점수</span>
                  <span className="cont com_blue_txt">4점</span>
                </div>
                <div className="info">
                  <span className="tit">점수/등급</span>
                  <span className="cont com_red_txt">158점 C등급</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접관 의견</span>
                  <span className="cont">태도나 모든 것이 좋으나 기타 다른 부분이 미흡합니다.</span>
                </div>
                <div className="info">
                  <span className="tit">파일명</span>
                  <span className="cont">
                    <div className="com_input_upload">
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </span>
                </div>
              </div>

              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">2024, 5기 </button>
                    <span className="date dot">미수료 1회 2회차</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  1회차 : 2024, 05, 12 : 출석 <br />
                  2회차 : 2024, 06, 23 ; 결석
                  <br />
                  3회차 : 2024, 09, 10 : 예정
                </div>
              </div>
            </div>
            <div className="detail_tit_sub">
              <p className="name">교육 배정</p>
            </div>
            <ul className="training_list">
              <li className="com_input_wrap flex_row">
                <select name="" id="" className="select">
                  <option value="회차 선택">회차 선택</option>
                </select>
                <select name="" id="" className="select">
                  <option value="기수 선택">기수 선택</option>
                </select>
                <div className="btn_box">
                  <button className="btn btn_minus_gray"></button>
                </div>
              </li>
              <li className="com_input_wrap flex_row">
                <select name="" id="" className="select">
                  <option value="회차 선택">회차 선택</option>
                </select>
                <select name="" id="" className="select">
                  <option value="기수 선택">기수 선택</option>
                </select>
                <div className="btn_box">
                  <button className="btn btn_minus_gray"></button>
                </div>
              </li>
              <li className="com_input_wrap flex_row">
                <select name="" id="" className="select">
                  <option value="회차 선택">회차 선택</option>
                </select>
                <select name="" id="" className="select">
                  <option value="기수 선택">기수 선택</option>
                </select>
                <div className="btn_box">
                  <button className="btn btn_minus_gray"></button>
                  <button className="btn btn_add_gray"></button>
                </div>
              </li>
            </ul>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default LearnerTraining;
